<template>
  <div class="org-content" v-loading="loading">
    <headBox title="组织管理"></headBox>
    <div class="org-body">
      <organizeTree></organizeTree>
      <div class="right">
        <!-- 搜索选中员工时，不显示 -->
        <div class="top-title" v-if="currentNode.level != 3">
          <div :class="currentNode.useStatus == 1 ? 'green-tag' : 'red-tag'" v-if="currentNode.useStatus && currentNode.level != 1">
            {{ currentNode.useStatus == 1 ? '已启用' : '已禁用' }}
          </div>
          <div class="title" :class="{ disabled: currentNode.useStatus == 0 }">{{ currentNode.deptmantName }}</div>
          <template v-if="accountLevel == 1 && currentNode.level != 1">
            <!-- 编辑机构 -->
            <div class="bj-btn" @click="editLowerMechan">
              <img src="@static/images/orgManage/bj.png" />
              <span>编辑</span>
            </div>
            <div class="cp-btn" @click="viewProduct()">
              <i class="iconfont icon-chanpinfeishuai" style="font-size: 15px; vertical-align: middle; margin-right: 5px"></i>
              <span>产品费率</span>
            </div>
            <!-- 删除机构 -->
            <div class="cp-btn">
              <span class="el-icon-delete" v-if="isDel == 1" @click="deleteSelected(currentNode, 'mechan')"> 删除</span>
              <el-tooltip class="item" effect="dark" :content="computedTips()" v-else placement="top">
                <span class="el-icon-delete disabled"> 删除</span>
              </el-tooltip>
            </div>
          </template>
          <div class="top-right">
            <el-button type="primary" plain @click="goRank">业绩排行</el-button>
            <el-button type="primary" :disabled="currentNode.useStatus == 0" @click="adduser" v-if="accountLevel == 2 || accountLevel == 1">新增员工</el-button>
          </div>
        </div>

        <div class="mechanism">
          <div class="bar" v-if="currentNode.level != 3">
            <el-form :inline="true" class="rform" label-width="80px">
              <el-form-item label="员工姓名">
                <el-input v-model="formInline.name" type="text" placeholder="请输入员工姓名" clearable></el-input>
              </el-form-item>
              <el-form-item label="联系方式">
                <el-input v-model.number="formInline.mobile" type="text" :maxlength="11" placeholder="请输入联系方式" clearable></el-input>
              </el-form-item>
              <el-form-item label="状态">
                <el-radio-group v-model="formInline.useStatus" @change="query()">
                  <el-radio label="">全部</el-radio>
                  <el-radio label="0">禁用</el-radio>
                  <el-radio label="1">启用</el-radio>
                </el-radio-group>
              </el-form-item>
              <el-button class="cxbt org-btn" type="primary" @click="query">查询</el-button>
            </el-form>
            <!-- 子机构表 -->
          </div>
          <div class="org-content" :class="{ 'only-staff': currentNode.level == 3 }">
            <!-- 员工列表不显示业绩排行 -->
            <el-table ref="singleTable" :data="tableData" class="list-table" border style="width: 100%" tooltip-effect="dark" v-loading="loading">
              <el-table-column property="name" align="left" min-width="130" label="员工姓名" show-overflow-tooltip>
                <template slot-scope="scope"
                  ><i v-if="scope.row.type == 1" style="color: #f47900; font-weight: 600" class="el-icon-user"></i> {{ scope.row.name }}
                </template>
              </el-table-column>
              <el-table-column property="mobile" label="手机号" min-width="120" show-overflow-tooltip></el-table-column>

              <el-table-column property="" min-width="260" label="产品模板（code）" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.productTemplateName }}<span v-if="scope.row.productTemplateCode">（{{ scope.row.productTemplateCode }}）</span></span
                  >
                </template>
              </el-table-column>
              <el-table-column property="" min-width="260" label="费率模板（code）" show-overflow-tooltip>
                <template slot-scope="scope">
                  <span
                    >{{ scope.row.commissonTemplateName }}<span v-if="scope.row.commissonTemplateCode">（{{ scope.row.commissonTemplateCode }}）</span></span
                  >
                </template>
              </el-table-column>
              <el-table-column property="useStatus" min-width="100" label="状态">
                <template slot-scope="scope">
                  <span class="green-tag" v-if="scope.row.useStatus == '1'">已启用</span>
                  <span class="red-tag" v-if="scope.row.useStatus == '0'">已禁用</span>
                </template>
              </el-table-column>
              <el-table-column label="操作" min-width="300" fixed="right">
                <template slot-scope="scope">
                  <div class="table-btn-text">
                    <div class="btn" :class="{ disabled: currentNode.useStatus == 0 }" @click="bjclick(scope.row)">编辑信息</div>
                    <div class="btn" @click="subuser(scope.row)">查看业绩</div>
                    <div class="btn" v-if="scope.row.mechanId != userinfo.mechanId || scope.row.type != 1" @click="viewProduct(scope.row)">产品费率</div>
                    <el-tooltip class="item" effect="dark" content="请前往商品库菜单查看产品费率" placement="top" v-else>
                      <div class="btn disabled">产品费率</div>
                    </el-tooltip>
                    <div class="btn" v-if="scope.row.isDel === '1' || scope.row.isDel === undefined" @click="deleteSelected(scope.row, 'staff')">删除</div>
                    <el-tooltip class="item" effect="dark" content="此员工已有业绩，不可删除" placement="top" v-else>
                      <div class="btn disabled">删除</div>
                    </el-tooltip>
                  </div>
                </template>
              </el-table-column>
            </el-table>
            <!-- 当前点击的不是员工的时候才显示分页 -->
            <el-pagination
              class="page"
              @size-change="handleSizeChange"
              :current-page.sync="formInline.pageNum"
              background
              layout="total, sizes, prev, pager, next, jumper"
              @current-change="singleTablePage"
              :page-sizes="[10, 20, 30, 40]"
              :total="singleTableTotal"
            >
            </el-pagination>
          </div>
        </div>
      </div>
    </div>
    <!-- 费率配置弹窗 -->
    <feeConfig ref="feeConfig" :showBtn="showBtn" @reloadUser="queryMechanSubAccount"></feeConfig>
    <!-- 新增员工 -->
    <addStaffDialog ref="addStaffRef"></addStaffDialog>
    <!-- 修改员工 -->
    <modifyStaff @reload="queryMechanSubAccount" ref="modifyStaffRef"></modifyStaff>
    <!-- 修改下级机构 -->
    <modifyLowerMechan ref="modifyLowerMechanRef"></modifyLowerMechan>
  </div>
</template>
<script>
import headBox from '@/components/head.vue';
import feeConfig from '../feeTemplate/components/feeConfig/feeConfig.vue';
import modifyStaff from './components/modifyStaff.vue';
import addStaffDialog from './components/addStaffDialog.vue';
import modifyLowerMechan from './components/modifyLowerMechanModal.vue';
import organizeTree from './components/organizeTree.vue';
export default {
  components: {
    headBox,
    organizeTree,
    feeConfig,
    modifyStaff,
    addStaffDialog,
    modifyLowerMechan
  },
  data: () => ({
    isDelJs: {}, // 1.isDepartment=true，表示有部门不能删除 2.isMemeber=true，表示有员工不能删除 3.isAchievements=true，表示有业绩不能删除; 判断需按顺序判断
    loading: false,
    isDel: 0, // 二级机构或部门是否可删除 1是 0 否
    btnLoading: false,
    showBtn: true,
    formInline: {
      mechanId: '',
      deptId: '',
      mobile: '',
      useStatus: '',
      name: '',
      pageNum: 1,
      pageSize: 10,
      productTemplateCode: ''
    },
    addVisible: false,
    singleTableTotal: 0,
    tableData: [],
    loading: false,
    accountLevel: '', // 当前账号级别，1一级机构，2二级机构，3员工
    currentNode: {}, // 当前选中节点数据
    userinfo: {} // 当前登录账号信息
  }),
  computed: {
    computedTips() {
      return () => {
        if (this.isDelJs) {
          if (this.isDelJs.isMemeber) {
            return '此机构已有员工，不可删除';
          } else if (this.isDelJs.isAchievements) {
            return '此机构已有业绩，不可删除';
          }
        }
      };
    }
  },
  watch: {
    '$store.getters.orgLoading': {
      handler(val) {
        this.loading = val;
      },
      immediate: true,
      deep: true
    },
    '$store.getters.currentNode': {
      handler(val) {
        if (val) {
          this.currentNode = JSON.parse(this.$store.getters.currentNode);
        }
      },
      deep: true,
      immediate: true
    },
    // 监听当前点击的tree的id变动，刷新右侧页面信息
    'currentNode.deptId': {
      handler(val) {
        this.formInline = {
          mechanId: '',
          deptId: '',
          mobile: '',
          useStatus: '',
          name: '',
          pageNum: 1,
          pageSize: 10
        };
        this.queryMechanSubAccount();
      },
      deep: true,
      immediate: true
    }
  },
  created() {
    // 当前账号数据
    this.accountLevel = this.$tools.getLocal('userinfo').level;
    this.userinfo = this.$tools.getLocal('userinfo');
  },
  methods: {
    // 分页
    handleSizeChange(val) {
      this.formInline.pageSize = val;
      this.query();
    },
    query() {
      this.formInline.pageNum = 1;
      this.queryMechanSubAccount();
    },
    // 业绩
    subuser(row) {
      this.$router.push({
        path: '/childAchiev',
        query: {
          id: row.id,
          mobile: row.mobile,
          name: row.name,
          time: row.createTime.substring(0, 10)
        }
      });
    },
    queryMechanSubAccount() {
      this.loading = true;
      if (!this.currentNode.deptId) return;
      if (this.currentNode.level == 3) {
        // 选择的节点是员工
        this.formInline.id = this.currentNode.deptId;
      } else {
        this.formInline.mechanId = this.currentNode.deptId;
      }
      this.$http({
        url: '/master/subAccount/queryUsersPage',
        type: 'put',
        params: this.formInline
      })
        .then(data => {
          this.loading = false;
          this.tableData = data.data;
          this.singleTableTotal = data.total;
          this.isDel = data.isDel;
          this.isDelJs = data.isDelJs;
        })
        .catch(e => {
          this.loading = false;
        });
    },
    // 业绩排行
    goRank() {
      let routeUrl = this.$router.resolve({
        path: '/childRank',
        query: { id: this.currentNode.deptId, level: this.currentNode.level }
      });
      window.open(routeUrl.href, '_blank');
    },
    // 编辑二级机构
    editLowerMechan() {
      // 传入当前选中机构的id
      this.$refs.modifyLowerMechanRef.open(this.currentNode.deptId);
    },
    singleTablePage(val) {
      this.formInline.pageNum = val;
      this.queryMechanSubAccount();
    },
    adduser() {
      this.$refs.addStaffRef.open({ mechanId: this.currentNode.deptId });
    },
    // 编辑员工
    bjclick(row) {
      this.$refs.modifyStaffRef.open(row);
    },
    // 删除员工、或者机构
    deleteSelected(item, flag) {
      this.$confirm('此操作将永久删除, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          let params = {};
          let url = '/master/mechanDept/delMechan';
          if (flag == 'staff') {
            // 删除员工
            params = {
              userId: item.id
            };
            url = '/master/mechanDept/delUser';
          } else if (flag == 'mechan') {
            // 删除机构
            params = {
              mechanId: item.deptId
            };
          }
          this.$http({
            url,
            type: 'DELETE',
            params: params
          })
            .then(res => {
              if (res.httpCode == 200) {
                this.$message.success('删除成功');
                if (flag == 'staff') {
                  this.queryMechanSubAccount();
                } else {
                  // 清除当前选中的节点
                  localStorage.removeItem('CURRENTNODEKEY');
                  // 刷新组织树
                  this.$bus.$emit('refreshTree');
                }
              }
            })
            .catch(e => {});
        })
        .catch(() => {});
    },
    // 新增下级机构
    addLowerMechan() {
      this.$refs.modifyLowerMechanRef.open();
    },
    // 机构产品
    viewProduct(data = null) {
      let params = {
        // ...this.currentNode
      };
      if (data) {
        params.userId = data.id;
        params.userName = data.name;
        params.deptmantName = this.currentNode.deptmantName;
        params.deptId = this.currentNode.deptId;
        params.commissonTemplateName = data.commissonTemplateName;
        params.commissonTemplateId = data.commissonTemplateId;
        params.commissonTemplateCode = data.commissonTemplateCode;
        params.type = data.type;
        if (data.type == 1) {
          params.commissonTemplateName = this.currentNode.commissonTemplateName;
          params.commissonTemplateId = this.currentNode.commissonTemplateId;
          params.commissonTemplateCode = this.currentNode.commissonTemplateCode;
        }
        this.showBtn = false;
      } else {
        console.log('???');
        params = {
          ...this.currentNode
        };
        this.showBtn = true;
      }
      this.$nextTick(() => {
        this.$refs.feeConfig.open(params);
      });
    }
  }
};
</script>
<style lang="scss" scoped>
@import './index.scss';
</style>
<style lang="scss">
.dept-edit-modal {
  .el-dialog__body {
    padding: 20px 50px 42px;
  }
  .dialog-footer {
    padding-top: 15px;
  }
}
</style>
